import { useState, useEffect } from 'react'
import { useLoginStore } from '@/store/LoginStore.ts'

/**
 * 앱 초기 로딩 시 HttpOnly 쿠키(Refresh Token)를 이용해 
 * Access Token을 복구(Silent Refresh)하는 훅
 */
export const useAuthInit = (options: { enabled?: boolean } = { enabled: true }) => {
    const [isInitialized, setIsInitialized] = useState(false)
    const { login, logout, accessToken } = useLoginStore()

    useEffect(() => {
        const initializeAuth = async () => {
            // 초기화가 비활성화된 경우(예: 공용 페이지) 바로 완료 처리
            if (options.enabled === false) {
                setIsInitialized(true)
                return
            }

            // 이미 메모리에 토큰이 있다면 초기화 완료
            if (accessToken) {
                setIsInitialized(true)
                return
            }

            try {
                const { apiRefresh } = await import('@/api/auth/refresh.ts')
                const newAccessToken = await apiRefresh()

                if (newAccessToken) {
                    await login('', newAccessToken)
                }
            } catch (error) {
                // 리프레시 토큰이 없거나 만료된 경우 (게스트 상태)
                await logout()
            } finally {
                setIsInitialized(true)
            }
        }

        initializeAuth()
    }, [options.enabled])

    return isInitialized
}
